import Screen from "./Screen";

export default class LoadingScreen extends Screen {
  init () {
    this._isOpen = true;
    //TODO PROGRESS BAR
  }
};